// ----------------------------------------------------------------------------
// Nombre del Programa : ConfiguracionesNosotros
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 22/JUN/2024
// Descripcion General : Clase que se utiliza para el texto dinamico de sobre nosotros
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Se modificaron etiquetas 20/AGO/2024
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------


import './ConfiguracionesNosotros.scss';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Button } from 'react-bootstrap';
import { BotonRegresar } from '../../../components/boton-regresar/BotonRegresar';
import { useEffect, useState, useRef, useMemo } from 'react';
import { Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useNavigate, useParams } from 'react-router-dom';
import { StatusAlertService } from 'react-status-alert';
import { ContenidoDinamicoProps } from '../../../interfaces/contenidodinamicoInterfaces';
import ReactQuill, { Quill } from 'react-quill';
import ImageEdit from 'quill-image-edit-module';
import 'react-quill/dist/quill.snow.css';
import { getContenidoDinamico, postContenidoDinamico } from '../../../Services/ConfiguracionesService';


var Size = Quill.import('attributors/style/size') as any;
Size.whitelist = [
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '25px',
  '30px',
  '40px',
  '50px',
];
Quill.register(Size, true);

/*var Font = Quill.import("formats/font");
Font.whitelist = ["Arial", "Serif", "Helvetica", "Frutiger", "Swift", "Futura", "Gotham", "Monospace", "Roboto", "Ubuntu", "Raleway", "Lato", "Rubik"];
Quill.register(Font, true);*/

Quill.register('modules/imageEdit', ImageEdit);
//Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste)

let quill: any = null;

export const ConfiguracionesNosotros = () => {
  const [cargado, setCargado] = useState<boolean>(false);
  const [titulo, setTitulo] = useState('');
  const [contenido, setContenido] = useState('');


  const quillEl = useRef(null);

  useEffect(() => {
    const quillRef: any = quillEl?.current;
    if (quillRef) {
      quill = quillRef?.getEditor();
    }
  }, []);

  const colors = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466',
  ];

  const modul = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          //[{ font: Font.whitelist }],
          [{ font: [] }],
          [
            'bold',
            'italic',
            'underline',
            'strike',
            'blockquote',
            'link',
            'code-block',
            { align: [] },
          ],
          [{ size: Size.whitelist }],
          [{ color: colors }, { background: colors }],
          [{ list: 'ordered' }, { list: 'bullet' }],
        ]
      },
      clipboard: {
        matchVisual: false,
      },
    }),
    []
  );

  const navigate = useNavigate();

  useEffect(() => {
    getContenidoDinamico("SBN").then((response) => {
      if (response.data && response.data.data) {
        setTitulo(response.data.data.titulo);
        setContenido(response.data.data.contenido);
        setCargado(true);
        /*setEditorState(EditorState.createWithContent(
          ContentState.createFromBlockArray(
            htmlToDraft(response.data.data[0].contenido)
          )));*/
      }
    });
  }, []);

  const guardarContenidoDinamico = async () => {
    if (titulo === '') {
      StatusAlertService.showError('Ingrese el titulo');
      return;
    }
    else if (contenido === '') {
      StatusAlertService.showError('Agregue el contenido');
      return;
    }

    let contenidodinamico = {} as ContenidoDinamicoProps;

    contenidodinamico.tipocontenido = "SBN";
    contenidodinamico.titulo = titulo;
    contenidodinamico.contenido = contenido;

    //console.log('comuicado', comuicado)

    const response: any = await postContenidoDinamico(contenidodinamico).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      //navigate(-1);
      StatusAlertService.showSuccess('Guardado Exitosamente');
    }

  };

  const onChangeContenido = (target: any) => {
    setContenido(target);
  };

  const enterTexto = (target: any) => {
    if (target.key === 'Enter') {
      target.preventDefault();
    }
  };
  return (
    <>
      <Row className="pt-3 mb-2">
        <BotonRegresar></BotonRegresar>
      </Row>
      <div>
        <Row className="mt-3">
          <Col>
            <Row className="titulo">
              <Col className="heading-1">
                Sobre nosotros
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <Form.Label>Titulo</Form.Label>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder=""
                    aria-label="Search"
                    value={titulo}
                    maxLength={200}
                    onKeyPress={enterTexto}
                    onChange={(e) => setTitulo(e.target.value)}
                    className="borde-rojo"
                  />
                </Form>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <ReactQuill
                  ref={quillEl}
                  theme="snow"
                  placeholder="Escribe..."
                  className="editor-class"
                  modules={modul}
                  value={contenido}
                  preserveWhitespace
                  onChange={(e) => onChangeContenido(e)}
                //onChange={setContenido}
                />
              </Col>
            </Row>
            <div className="d-flex flex-row-reverse bd-highlight mt-3">
              <Button
                variant="primary"
                className="float-end"
                onClick={() => guardarContenidoDinamico()}
              >
                Guardar cambios
              </Button>
              <Button
                variant="secondary"
                className="float-end me-3"
                onClick={() => navigate(-1)}
              >
                Cancelar
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
